export const codeSpiel = "Didn't receive code?";
export const resend = "Resend";
export const enterButton = "ENTER";
export const loading = "LOADING...";
